export enum Breakpoint {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
  wide = 'wide'
}
